import React, { Component } from 'react';

export default class NotFound extends Component {
  render() {
    return <h1>404</h1>;
  }
}
